import React from 'react';

type FormLinkProps = { children: React.ReactNode };

const FormLink = ({ children }: FormLinkProps) => {
	return <div className="vtex-login-2-x-formLinkContainer formLinkContainer flex justify-end ph0 pv2">{children}</div>;
};

export default FormLink;
